module.exports = __webpack_public_path__ + "img/sz-press-conference.92b7b1d8.png";